import { render, staticRenderFns } from "./DealNum.vue?vue&type=template&id=5c0cf958&scoped=true&"
import script from "./DealNum.vue?vue&type=script&lang=js&"
export * from "./DealNum.vue?vue&type=script&lang=js&"
import style0 from "./DealNum.vue?vue&type=style&index=0&id=5c0cf958&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0cf958",
  null
  
)

export default component.exports